import SessionService from '@/services/SessionService'

export default {
  namespaced: true,
  state: {
    isRestored: false
  },
  getters: {
    isSameUser() {
      return localStorage.getItem('lastCodigoAccesso') === SessionService.getCodigoAccesso()
    }
  },
  mutations: {
    setIsRestored(state) {
      localStorage.setItem('lastCodigoAccesso', SessionService.getCodigoAccesso())
      state.isRestored = true
    },

    clear(state) {
      state.isRestored = false
    }
  },
  actions: {
    // Called from router
    async restore({state, getters, rootGetters, commit, dispatch}) {
      if (!state.isRestored) {
        try {
          if (!getters.isSameUser) {
            await dispatch('agricultor/clearAgricultor', null, {root:true})
            await dispatch('temporada/clearTemporadaAgricultor', null, {root:true})
            await dispatch('admin/clearEsAdmin', null, {root:true})
            await dispatch('establecimientos/clearEstablecimiento', null, {root:true})
            await dispatch('establecimientos/clearEstablecimientoList', null, {root:true})
            await dispatch('clear')
          } else {
            await dispatch('agricultor/restoreAgricultor', null, {root:true})
            await dispatch('admin/fetchEsAdmin', null, {root:true})
            await dispatch('establecimientos/restoreEstablecimiento', null, {root:true})
            // await dispatch('establecimientos/restoreGrupoExplotacion', null, {root:true})

            if (rootGetters['agricultor/isAgricultorSet']) {
              await dispatch('temporada/restoreTemporada', null, {root:true})
              await dispatch('fichas/restoreFichaAgricola', null, {root:true})
            }
          }
        } finally {
          // Always execute this so that App, FhMenuTemporada, FhMenuAgricultor, and FhMenuFichaAgricola components
          // can stop busy wait in created hook
          commit('setIsRestored')
        }
      }
    },

    async logout({commit, dispatch}) {
      localStorage.removeItem('lastCodigoAccesso')
      localStorage.removeItem('rowsPerPage')
      localStorage.removeItem('selectedAgricultor')
      localStorage.removeItem('selectedFichaAgricola')
      localStorage.removeItem('selectedTemporada')
      localStorage.removeItem('selectedEstablecimiento')
      localStorage.removeItem('selectedGrupoExplotacion')
      localStorage.removeItem('grupoExplotacionList')
      localStorage.removeItem('lastEstablecimiento')
      localStorage.removeItem('selectedFichaGanadera')
      await dispatch('clear', {isLogout: true})
      commit('clear')
    },

    async clear({dispatch}, payload) {
      // Except variedad, maquina, zona, producto, rubro, because they can't be changed and don't change between agricultor

      if (payload && payload.isLogout) {
        await dispatch('agricultor/clearAgricultor', null, {root:true})
        await dispatch('temporada/clearTemporadaAgricultor', null, {root:true})
        await dispatch('admin/clearEsAdmin', null, {root:true})
      }

      if (payload && !payload.isSetTemporada || !payload) {
        await dispatch('personal/clearPersonal', null, {root:true})
        await dispatch('maquinas/clearInventario', null, {root:true})
      }

      await dispatch('fichas/clearFichaAgricola', null, {root:true})
      await dispatch('fichas/clearFichaGanadera', null, {root:true})
      await dispatch('movimientos/clearMovimientosList', null, {root:true})
      await dispatch('movimientos/clearListaMovimientoAnimal', null, {root:true})
      await dispatch('movimientos/clearListaReproducciones', null, {root:true})
      await dispatch('lotes/clearListaLotes', null, {root:true})
      await dispatch('lotes/clearListaInventarios', null, {root:true})
      await dispatch('lotes/clearInventariosActual', null, {root:true})
      await dispatch('lotes/clearInventarioResultado', null, {root:true})
      await dispatch('precipitacion/clearPrecipitacion', null, {root:true})
      await dispatch('rendimientoCosecha/clearRendimientoCosecha', null, {root:true})
      await dispatch('trabajos/clearTrabajo', null, {root:true})
      await dispatch('trabajos/clearTrabajoFicha', null, {root:true})
      await dispatch('alquiler/clearAlquiler', null, {root:true})
      await dispatch('grupoExplotacion/clearListaGrupoExplotacion', null, {root:true})
      await dispatch('variedades/clearListaVariedadTemporadaAgricultor', null, {root:true})
    },
  }
}
